module.exports = __webpack_public_path__ + "img/generic-background@2x.ac81c70e.png";